/** Build-time configuration (VITE_* variables are inlined into the static bundle). */
export const API_URL = import.meta.env.VITE_API_URL ?? 'http://localhost:3010';
export const WS_URL = import.meta.env.VITE_WS_URL ?? `${API_URL.replace(/^http/, 'ws')}/v1/stream`;
/** Bot username for the Telegram Login Widget on the web (Mini App sign-in needs no config). */
export const TELEGRAM_BOT = import.meta.env.VITE_TELEGRAM_BOT ?? '';
/** Players reach a person here (Profile → Help & support; the bot's Help shows the same account). */
export const SUPPORT_TELEGRAM = 'EdilGamesSupport';
export const MIN_AGE = 21;
export const TERMS_VERSION = '2026-09';
export const POLL_MS = 5000;
export const TIME_SYNC_MS = 60_000;
